import React from 'react';
import { createFragmentContainer, graphql } from 'react-relay';

// components
import { SbSharedRefineMenuMultiSelectSearch } from '../SbSharedRefineMenuMultiSelect/SbSharedRefineMenuMultiSelectSearch';

export const SbSharedRefineMenuFilterMetalComponent = props => (
    <SbSharedRefineMenuMultiSelectSearch {...props} />
);

export const SbSharedRefineMenuFilterMetal = createFragmentContainer(
    SbSharedRefineMenuFilterMetalComponent,
    {
        viewer: graphql`
            fragment SbSharedRefineMenuFilterMetal_viewer on Viewer {
                ...SbSharedRefineMenuMultiSelectSearch_viewer
            }
        `,
        searchBrowse: graphql`
            fragment SbSharedRefineMenuFilterMetal_searchBrowse on SearchBrowseQueryConnection {
                ...SbSharedRefineMenuMultiSelectSearch_searchBrowse
            }
        `,
    }
);
